import { Radio } from 'antd';

import React from 'react';

function RadioInput({ ...rest }) {
  return <Radio.Group {...rest} />;
}

export default RadioInput;
